export const Constents = {
  //binder Constant
  BINDER_TITLE: {
    en: "Binder Summary",
    fr: "Résumé du Binder",
  },
  EFF_DATE: {
    en: "Effective Date",
    fr: "Date d'effet",
  },
  EXPIRY_DATE: {
    en: "Expiry Date",
    fr: "Date d'expiration",
  },
  COMMENTS: {
    en: " Broker Comment/Notes",
    fr: " Commentaire/Notes du Courtier",
  },
  COMMENT_TEXT: {
    en: "Enter a comment",
    fr: "Entrez un commentaire",
  },
  EDIT_LABLE: {
    en: "Edit",
    fr: "Éditer",
  },
  SAVE_BTN: {
    en: "Save",
    fr: "Enregistrer",
  },
  BACK_BTN: {
    en: "Back to Application",
    fr: "Retour à la proposition d'assurance",
  },
  //prospect constant
  PROSPECT_TITLE: {
    en: "Quote Summary",
    fr: "Résumé de la soumission",
  },
  HEADING: {
    en: "Add or edit Quote details",
    fr: "Ajouter ou modifier les détails de la soumission",
  },
  SUB_HEADING: {
    en: "To help you present options to your client, you can manually add or edit quotes that you have received from insurers outside of Quotey.",
    fr: "Pour vous aider à présenter des options à votre client, vous pouvez ajouter ou modifier manuellement des devis que vous avez reçus d'assureurs en dehors de Quotey.",
  },
  QUOTES_NOTES: {
    en: "Quote Comment/Notes",
    fr: "Commentaire/Notes de la soumission",
  },
};

// export const Constents = [
//   // Binder Constants
//   {
//     en: "Binder Summary",
//     fr: "Résumé du Binder",
//   },
//   {
//     en: "Effective Date",
//     fr: "Date d'effet",
//   },
//   {
//     en: "Expiry Date",
//     fr: "Date d'expiration",
//   },
//   {
//     en: " Broker Comment/Notes",
//     fr: " Commentaire/Notes du Courtier",
//   },
//   {
//     en: "Enter a comment",
//     fr: "Entrez un commentaire",
//   },
//   {
//     en: "Edit",
//     fr: "Éditer",
//   },
//   {
//     en: "Save",
//     fr: "Enregistrer",
//   },
//   {
//     en: "Back to Application",
//     fr: "Retour à l'Application",
//   },

//   // Prospect Constants
//   {
//     en: "Quote Summary",
//     fr: "Résumé du Devis",
//   },
//   {
//     en: "Add or edit Quote details",
//     fr: "Ajouter ou modifier les détails du devis",
//   },
//   {
//     en: "To help you present options to your client, you can manually add or edit quotes that you have received from insurers outside of Quotey.",
//     fr: "Pour vous aider à présenter des options à votre client, vous pouvez ajouter ou modifier manuellement des devis que vous avez reçus d'assureurs en dehors de Quotey.",
//   },
//   {
//     en: "Quote Comment/Notes",
//     fr: "Commentaire/Notes du Devis",
//   },
// ];
